import styled from "styled-components";

export const ModalWrapper = styled.div<{ $isOpen: boolean; $fullScreen: boolean }>`
  position: fixed;
  /* Above the sidebar and chat list (they go up to 9999) */
  z-index: 10000;
  top: 0;
  /* When not fullScreen, keep the 240px nav sidebar (SidebarWrapper) usable */
  left: ${(props) => (props.$fullScreen ? "0" : "240px")};
  height: 100vh;
  width: ${(props) => (props.$fullScreen ? "100vw" : "calc(100vw - 240px)")};
  background-color: #001d30;
  display: ${(props) => (props.$isOpen ? "flex" : "none")};
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.large};
  padding-top: 2rem;
  padding-bottom: 2rem;
  overflow-y: auto;
  overflow-x: hidden;

  @keyframes modalFadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  animation: modalFadeIn 0.5s ease;

  > img {
    /* With the nav sidebar visible the Mike branding is redundant */
    display: ${(props) => (props.$fullScreen ? "block" : "none")};
    z-index: 10;
    position: relative;
    width: auto;
    height: 3rem;
    margin-bottom: 1rem;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    /* On mobile the nav collapses, so the modal always takes the full screen */
    left: 0;
    width: 100vw;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;

    > img {
      display: block;
      height: 2.5rem;
      margin-bottom: 0.75rem;
    }
  }
`;

export const AnimatedBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;

  @keyframes blob {
    0% { transform: translate(0px, 0px) scale(1); }
    33% { transform: translate(30px, -50px) scale(1.1); }
    66% { transform: translate(-20px, 20px) scale(0.9); }
    100% { transform: translate(0px, 0px) scale(1); }
  }

  .blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    mix-blend-mode: overlay;
    opacity: 0.1;
    animation: blob 7s infinite;
  }

  .blob-1 {
    top: 0;
    left: 25%;
    width: 24rem;
    height: 24rem;
    background-color: #3b82f6;
    animation-delay: 0s;
  }

  .blob-2 {
    top: 0;
    right: 25%;
    width: 24rem;
    height: 24rem;
    background-color: #a855f7;
    animation-delay: 2s;
  }

  .blob-3 {
    bottom: -8rem;
    left: 33%;
    width: 24rem;
    height: 24rem;
    background-color: #34d399;
    animation-delay: 4s;
  }
`;

export const ModalDisplayer = styled.div`
  background-color: #fff !important;
  z-index: 10;
  position: relative;

  @keyframes modalRiseIn {
    from {
      opacity: 0;
      transform: translateY(12px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  animation: modalRiseIn 0.5s ease;
  max-width: 520px;
  width: 100%;
  padding: 2.5rem;
  border-radius: 1rem;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  border: 1px solid #F2F3F7;
  margin-bottom: 1rem;
  margin-left: auto;
  margin-right: auto;
  height: auto;
  min-height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.medium};

  h1 {
    margin: 0;
    margin-bottom: ${(props) => props.theme.spacing.medium};
  }

  > button {
    width: 100%;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    width: 90%;
    padding: 1.5rem;
    margin-bottom: 0.5rem;
    max-width: calc(100% - 1rem);
    margin-left: auto;
    margin-right: auto;
  }
`;
